import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";

// Compact, mobile-first, client-side search input reused across list pages.
export const SearchField = ({ value, onChange, placeholder, testid }) => (
  <div className="relative">
    <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
    <Input
      data-testid={testid}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="pl-9 pr-9 rounded-full"
    />
    {value && (
      <button
        type="button"
        data-testid={testid ? `${testid}-clear` : undefined}
        onClick={() => onChange("")}
        aria-label="Cancella ricerca"
        className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
      >
        <X className="h-4 w-4" />
      </button>
    )}
  </div>
);
